import { BillwerkAddPaymentMethodRequest } from 'src/app/model/interfaces/billwerk-add-payment-method-request';
import { ApiPostRequest } from '../api-post-request';

export class PaymentMethodPostRequest extends ApiPostRequest
{
    public constructor(paymentMethodDetails: BillwerkAddPaymentMethodRequest, webapiBasepath: string)
    {
        super(
            'billwerk/addpaymentmethods',
            null,
            null,
            paymentMethodDetails,
            webapiBasepath
        );
    }
}
